import { defineSlotRecipe as e } from "@pandacss/dev";
const o = e({
  className: "property-card",
  slots: ["root", "image", "title", "description", "price", "container", "tags", "footer"],
  base: {
    root: {
      bg: "base.white",
      borderRadius: "4",
      w: "200px",
      h: "auto",
      overflow: "hidden"
    },
    image: {
      maxHeight: "130px",
      width: "100%",
      objectFit: "cover"
    },
    title: {
      color: "text-primary"
    },
    description: {
      color: "text-tertiary"
    },
    price: {
      my: "1",
      color: "text-primary"
    },
    container: {
      pos: "relative"
    },
    tags: {
      gap: "1",
      pos: "absolute",
      top: "4",
      left: "4"
    },
    footer: {
      p: "4"
    }
  }
});
export {
  o as propertyCardRecipe
};
